import { render } from "./Logo.vue?vue&type=template&id=c81ce4c4&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=c81ce4c4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard.lims.ninja/dashboard.lims.ninja/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81ce4c4"]])

export default __exports__